import React, { useEffect, useState } from 'react'
import UnitManagerScheduleDetailsManagement from './UnitManagerScheduleDetailsManagement'
import { useLocation } from 'react-router-dom'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function UnitManagerScheduleDetails(props) {
  const [successMsg, setSuccessMsg] = useState('')
  const [loadUnit, setLoadUnit] = useState(false)
  const [erroMsg, setErroMsg] = useState([])
  const [orgaoSchedule, setOrgaoSchedule] = useState('')
  const [loadingButton, setLoadingButton] = useState(false)
  const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
  const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
  const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

  const location = useLocation()
  const { result_search } = location.state
  const [unit, setUnit] = useState({
    name: result_search.NOME_UNIDADE,
    organ: { value: result_search.CODIGO_ORGAO, label: result_search.NOME_ORGAO },
    unidade: { value: result_search.CODIGO_UNIDADE, label: result_search.NOME_UNIDADE },
    dias_semana: result_search.DIAS_SEMANA,
    hora_inicio: result_search.HORA_INICIO,
    hora_fim: result_search.HORA_FIM,
    data_limite: result_search.DATA_LIMITE,
    motivo: result_search.MOTIVO_HORARIO_EXCECAO,
  })

  useEffect(() => {
    async function loadDefaultOrganSchedule() {
      const user = JSON.parse(localStorage.getItem('user'))
      const requestOptions = {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          authorization: user ? user.token : '',
          'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
        }),
        body: JSON.stringify({
          cpf_gestor: user.cpf_atendente,
          codigo_orgao: user.codigo_orgao,
        }),
      }
      await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/consultaHorarioOrgao`, requestOptions)
        .then(function (response) {
          if (response.ok) {
            response.json().then(function (data) {
              // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!
              setOrgaoSchedule({
                codigo_orgao: data.CODIGO_ORGAO,
                nome_orgao: data.NOME_ORGAO,
                dias_semana: data.DIAS_SEMANA,
                hora_inicio: data.HORA_INICIO,
                hora_fim: data.HORA_FIM,
              })
            })
          } else if (response.status === 422) {
            response.json().then(function (data) {
              if (!!data.errorCode && !!data.message) {
                // inserir a mensagem: data.message no aviso de erro
                console.log(data.message)
              } else {
                // inserir mensagem genérica
                console.log('Response error in gestao/detalhaUnidade BackendBalcao')
              }
            })
          } else if (response.status === 403) {
            response.json().then(function (data) {
              setModalInvalidSessionErrorTitle(data.title ? data.title : null)
              setModalInvalidSessionErrorMsg(data.message ? data.message : null)
              setModalInvalidSessionError(true)
            })
          } else {
            // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
            //setLoading(false);
            //setModalError(true);
            console.log('Request error in gestao/detalhaUnidade BackendBalcao')
          }
        })
        .catch(function (err) {
          console.error('Failed retrieving information', err)
        })
    }

    loadDefaultOrganSchedule()
    setLoadUnit(true)
  }, [])

  async function confirmUpdate() {
    setLoadingButton(true)
    const user = JSON.parse(localStorage.getItem('user'))

    const requestOptions = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        authorization: user ? user.token : '',
        'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
      }),

      body: JSON.stringify({
        cpf_gestor: user.cpf_atendente,
        codigo_orgao: unit.organ.value,
        codigo_unidade: unit.unidade.value,
        dias_semana: unit.dias_semana,
        hora_inicio: unit.hora_inicio,
        hora_fim: unit.hora_fim,
        data_limite: unit.data_limite,
        motivo_horario_excecao: unit.motivo,
      }),
    }

    await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/editaHorarioUnidade`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          response.json().then(function (data) {
            setSuccessMsg(data.message)
            setErroMsg(undefined)
          })
        } else {
          response.json().then(function (data) {
            setErroMsg(data.message)
            console.log('Erro no request de /gestao/horario/editaHorarioUnidade')
          })
        }
      })
      .catch(function (err) {
        console.error('Failed retrieving information', err)
      })
    setLoadingButton(false)
    window.scrollTo(0,0)
  }

  return (
    <>
      <ModalWarn
          id='modalWarnalertInvalidSession'
          appear={modalInvalidSessionError}
          title = { modalInvalidSessionErrorTitle }
          text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
          textButton2='Ir para tela inicial'
          actionButton2={() => { 
              document.getElementById("btnLogout").click();
          }}
      />
      <UnitManagerScheduleDetailsManagement
        pageTitle='Horário de exceção da Unidade'
        unit={unit}
        setUnit={setUnit}
        loadOperator={loadUnit}
        buttonBackRoute='/horariosUnidades'
        buttonEditRoute='/editarHorarioUnidade'
        confirmUpdate={confirmUpdate}
        orgaoSchedule={orgaoSchedule}
        history={props.history}
        erroMsg={erroMsg}
        fromSuccessMsg={successMsg}
        loadingButton={loadingButton}
      />
    </>
  )
}
